import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueProgressBar from "@aacassandra/vue3-progressbar";

const options = {
	color: "var(--Ultramarine-Blue)",
  failedColor: "#874b4b",
  height: "30px",
};
createApp(App).use(VueProgressBar, options).use(router).mount("#app");
